const API = {
    auth: {
        login: 'mechanic/loginSaas',
        register: 'mechanic/register',
        logout: 'user/logout',
        forgetpass: 'user/forgotPassword',
        verifyotp: 'user/emailCodeVerification',
        resetpassword: 'user/resetPasswordForSaas',
        shopRequest: 'mechanic/register',
        changePassword: 'user/changePasswordForSaas',
        passwordUpdate: 'user/passwordUpdatedAt',
        setFirstPassword: 'user/setPasswordSaas/',
    },
    supplier: {
        invoiceListByInventory: 'invoice/list-by-inventory-details',
        invoiceList: 'invoice/list-by-supplier-id',
        getlist: 'supplier/list',
        getDetail: 'supplier/get/',
        delete: 'supplier/delete/',
        create: 'supplier/create',
        update: 'supplier/update/',
        notes: {
            get: 'supplier-notes/list',
            delete: 'supplier-notes/delete/',
            create: 'supplier-notes/create',
            update: 'supplier-notes/update/',
        },
        supplierInvoice: {
            deletePart: 'supplier-invoice/deletePart',
            customerInvoice: 'supplier/customer-invoices/',
            create: 'supplier-invoice/create',
            getSingle: 'supplier-Invoice/get/',
            getList: 'supplier-invoice/list',
            update: 'supplier-Invoice/update/',
            common: 'supplier-Invoice/common-update/',
            delete: 'supplier-Invoice/delete/',
            recordPaymentCreate: 'supplier-payments/create',
            paymentId: 'supplier-payments/list-by-supplier-invoice/',
        },
    },
    savedService: {
        update: 'saved-services/update/',
        check: 'saved-services/check-exist',
        getDetail: 'saved-services/get/',
        getList: 'saved-services/list',
        groupList: 'saved-services/grouped-list',
        create: 'saved-services/create',
        categoryUpdate: 'saved-services/update-by-service-sub-category/',
        delete: 'saved-services/delete/',
    },
    inventory: {
        filter: 'inventory/filter',
        partSequence: 'inventory/get-next-part-sequence',
        supplierInvoiceList: 'supplier-Invoice/list-of-supplier-invoice-number',
        advisor: {
            create: 'shop-service-advisor/create',
            get: 'shop-service-advisor/list',
            update: 'shop-service-advisor/update/',
            delete: 'shop-service-advisor/delete/',
        },
        technician: {
            create: 'shop-service-technician/create',
            get: 'shop-service-technician/list',
            update: 'shop-service-technician/update/',
            delete: 'shop-service-technician/delete/',
        },
        getBtachList: 'inventory-batches/list',
        getPartList: 'inventory-items/list',
        getList: 'inventory/list',
        getOptimizedList: 'inventory/list-of-parts',
        getSingle: 'inventory/get/',
        getBatch: 'inventory-items/get-batch-details/',
        create: 'inventory/create',
        update: 'inventory/update/',
        checkInventory: 'inventory/check-before-update/',
        delete: 'inventory/delete',

        parts: {
            list: 'parts/list',
            create: 'parts/add',
            update: 'parts/update/',
            delete: 'parts/delete/',
        },
        partsBand: {
            create: 'parts-brand/create',
            list: 'parts-brand/list',
        },
        tyreModal: {
            create: 'tyre-model/create',
            list: 'tyre-model/list',
        },
        partsCategory: {
            create: 'parts-category/create',
            list: 'parts-category/list',
        },
        tableViewList: {
            partNumber: 'inventory/list-of-part-number',
            tyreDimension: 'inventory/list-of-tyre-dimension',
            partName: 'inventory/list-of-part-name',
            partCategory: 'inventory/list-of-part-category',
            partBrand: 'inventory/list-of-part-brand',
            tyreModel: 'inventory/list-of-tyre-model',
        },
    },
    account: {
        discountProgram: {
            get: 'membership-program/list',
            save: 'membership-program/save-changes',
            delete: '',
        },
        personal: {
            countryMasterList: 'countryMaster/list-of-country',
            getPersonalDetail: 'user/shopOwnerDetail',
            updatePersonalDetail: 'user/updatePersonalInfo',
            updateMembership: 'user/update-membership/',
            smsPhoneNumber: 'shop/sms-notification-phone-number',
            getThankyouDetail: 'shop/thankyou-email-settings',
            updateThankyouDetail: 'shop/update-thankyou-email-settings',
            sendThankyouDetail: 'shop/test-thankyou-email-settings',
        },
        shopDetails: {
            getshopDetails: 'shop/shopDetails',
            updateShopDetails: 'shop/shopImages',
            updateShopCertificates: 'shop/shopCertifications',
            shopBasicsUpdate: 'shop/shopBasicsUpdate',
            updateShopPrice: 'shop/default-hourly-rate',
            getUpdateShopPrice: 'shop/default-hourly-rate',
            defaultShopPrice: 'shop/default-shop-price',
        },
        shopImages: {
            get: 'shop/get-images',
            update: 'shop/add-images',
        },
        cancellationPolicy: {
            getpolicy: 'cancellationPolicy/list',
            addPolicy: 'cancellationPolicy/add',
            updatePolicy: 'cancellationPolicy/update',
            deletePolicy: 'cancellationPolicy/delete',
        },
        Estimates: {
            estimateFee: 'shop/updateEstimateFees',
        },
        termsAndWarrenty: {
            getTermsAndWarrenty: 'shop/termsAndWarranty',
            addTermsAndWarrenty: 'shop/add-term-and-warranty',
            updateTermsAndWarrenty: 'shop/edit-term-and-warranty',
            deleteTermsAndWarrenty: 'shop/delete-term-and-warranty',
            setDefaultTermsAndWarrenty: 'shop/set-default-term-and-warranty',
        },
        reschedulingPolicy: {
            getList: 'reschedulingPolicy/list',
            getById: 'reschedulingPolicy/get',
            update: 'reschedulingPolicy/update',
            add: 'reschedulingPolicy/add',
            delete: 'reschedulingPolicy/delete',
        },
        Amenities: {
            putAmenities: 'shop/updateShopAmenities',
            getAmenities: 'amenities/list',
        },

        shopHours: {
            getTimeZone: 'shop/get-timezone',
            ontarioHolidays: {
                getOntarioHolidays: 'shop/ontarioListing',
            },
        },
        shopHours: {
            getTimeZone: 'shop/get-timezone',
            getShopHours: '/shop/shopHours',
            ontarioHolidays: {
                getOntarioHolidays: '/shopHolidays/ontarioListing',
                updateOntarioHolidays: '/shopholidays/updateOntarioHolidays',
            },
            customHolidays: {
                getCustomHolidays: '/shopHolidays/customHolidayListing',
                updateCustomHolidays: '/shopHolidays/update',
                addCustomHolidays: '/shopHolidays/addCustomHoliday',
                deleteCustomHolidays: '/shopHolidays/delete',
            },
            businessHours: {
                updateBusinessHours: '/shop/updateBusinessHours',
            },
            operationalHours: {
                updateOperationHours: 'shop/shopOperationalHours',
            },
        },
        shopServices: {
            getServiceCategory: 'serviceCategory/list',
            shopServicesListing: 'shopServices/shopServices',
            getServiceSubCategory: 'serviceSubCategory/list',
            create: 'serviceSubCategory/create',
            shopWise: 'serviceSubCategory/list-shop-wise',
            addShopService: 'shopServices/addShopServices',
            updateShopService: 'shopServices/updateShopServices',
            updateShopServiceStatus: 'shopServices/updateShowShopService',
            deleteService: 'shopServices/deleteShopServices',
            getShopBasedCategory: 'shopServices/ShopServiceCategory',
            create: 'serviceSubCategory/create-with-shop-services',
            accountCreate: 'serviceSubCategory/',
            createCategory: 'serviceCategory/create',
        },
        notificationManage: {
            getNotificationStatus: 'notification/getNotificationStatus',
            updateNotificationStatus: 'user/update-preference',
        },
        billing: {
            getBillingHistory: 'subscriptionInvoice/list',
            getPlans: 'subscriptionPriceMaster/list',
            getCurrentPlan: 'subscriptionUserMaster/getByShop/',
            upgradePlan: 'subscriptionUserMaster/update/',
            addCard: 'paymentMethod/add',
            updatecard: 'subscriptionUserMaster/changePaymentMethod',
            upgradeManualPlan: 'subscriptionUserMaster/manual-to-stripe',
        },
        pdfSetting: {
            getList: 'pdf-setting/list',
            // getList: 'pdf-setting/visibility-list',
            getById: 'pdf-setting/get/',
            getByShopId: 'pdf-setting/get-by-shop/',
            update: 'pdf-setting/update',
            // update: 'pdf-setting/visibility-update',
            preview: 'pdf-setting/preview',
        },
    },

    notification: {
        notificationList: 'notification/list',
        markAsRead: 'notification/markAsRead',
        markAsReadById: 'notification/markRead/',
    },
    dashboard: {
        dashboardData: 'dashboard',
        requestEstimateListing: 'estimateRequest/EstimateRequest',
        requestEstimateDetail: 'estimateRequest/getEstimateRequest',
        requestApponitmentDetail: 'appointment/appointmentRequestDetail',
        requestAppointmentListing: 'appointment/appointment-requests',
        acceptDeclineRequest: 'estimate/estimateStatusManage',
        acceptDeclineAppointmentRequest: 'appointment/respondToRequestForSaas',
        updateEstimatePickUp: 'appointment/updatePickupTime',
        changeAssignee: 'appointment/assignee/',
    },

    vehicle: {
        getVehicleListByUserID: 'vehicle/list',
        getVehicleYearList: 'vehicle/vehicleYear',
        getVehicleMakeList: 'vehicleMake/list',
        getVehicleModelList: 'vehicleModel/list',
        getVehicleExperimentalModelList: 'vehicleModel/experimental/list',
        getProvinces: 'provinceMaster/list-of-province',
        check: 'vehicle/check-exists',
    },

    customer: {
        getCustomerList: 'shopCustomer/list',
        list: 'mechanic/customerList',
        detail: 'user/customerDetail/',
        vehicles: 'vehicle/list/',
        appointments: 'appointment/appointmentList',
        vehicleYear: 'vehicle/vehicleYear',
        vehicleMake: 'vehicleMake/list',
        vehicleModel: 'vehicleModel/experimental/list',
        vehicleModelCreateTemp: 'vehicleModel/experimental/create',
        vehicleTrim: 'vehicleModelTrim/list',
        vehicleTrimCreateTemp: 'vehicleModelTrim/new-trim/create',
        notesList: 'notes/list',
        addNote: 'notes/addNotesForCustomer',
        addVehicle: 'vehicle/addVehicle',
        importedVehicleAdded: 'vehicle/imported-vehicle-create',
        create: 'mechanic/createCustomer',
        edit: 'user/updateCustomer/',
        delete: 'user/deleteUser/',
        editVehicle: 'vehicle/updateVehicle/',
        deleteVehicle: 'vehicle/deleteVehicle/',
        editNote: 'notes/editNotes/',
        deleteNote: 'notes/delete/',
        decodeVIN: 'user/decode/',
        allCustomerList: 'mechanic/dbCustomer',
        customerListWithType: 'user/getCustomerList',
        mergeCustomerList: 'user/listForMergeCustomer',
        shopImportedCreate: 'user/create-customer-from-imported',
        mergeCustomerById: 'user/getImportCustomer/',
        importCustomerList: 'user/imported-customer-list',
        mergeCustomers: 'user/mergeCustomer',
        removeMergeCustomer: 'user/remove-from-import/',
        checkPhoneNumber: 'user/checkPhoneNumber',
        updatePhoneCustomer: 'user/updateCustomerDetails/',
        importCustomerDetail: 'user/getImportCustomer/',
        dismissCustomer: 'user/removeFromImport',
        customerDetilsWithType: 'user/getImportCustomer',
        cityList: 'cityMaster/list-of-city',
        provinceList: 'provinceMaster/list-of-province',
        countryList: 'countryMaster/listOfCountry',
        editImportedVehicle: 'vehicle/imported-vehicle-update/',
        deleteImportedVehicle: 'vehicle/imported-vehicle-delete/',
        decodeLicense: 'user/decode-liscence-number-plate',
        getCarfaxHistory: 'vehicle-service-history/fetch-vehicle-service-history',
    },

    estimate: {
        estimateList: 'estimate/estimateListSaas',
        estimateDetail: 'estimate/estimateDetail',
        servicesCategory: 'shopServices/ShopServiceCategory',
        servicesSubCategory: 'shopServices/ShopServiceSubCategory',
        termsAndWarranty: 'shop/termsAndWarranty',
        createEstimate: 'estimate/createEstimate',
        updateEstimate: 'estimate/update-estimate/',
        createDraftEstimate: 'estimate/createEstimateAsDraft',
        deleteDraft: 'estimate/deleteDraftEstimate',
        sentEstimateDetails: 'estimate/sendEstimatePdf',
        getEstimateRequestDetails: 'estimateRequest/getEstimateRequest',
        finalizedDelete: 'estimate/delete/',
    },

    invoice: {
        invoiceList: 'invoice/list',
        vehicleList: 'vehicle/list',
        invoiceDetails: 'invoice/get',
        create: 'invoice/create',
        finalizedDelete: 'invoice/delete/',
        updateFinalizeInvoice: 'invoice/update/',
        customerList: 'shopCustomer/list',
        createDraft: 'invoice/draftInvoice',
        deleteDraft: 'invoice/delete-draft',
        getCustomerList: 'mechanic/shopCustomerWithAppointment',
        sentInvoiceDetails: 'invoice/send-invoice-pdf',
        downloadInvoiceSalesReport: 'reports/invoice-sales-report',
        downloadAccountReceivableReport: 'reports/accounts-receivable-report',
        downloadStatementOfAccountReport: 'reports/statement-of-account-report',
        fees: {
            create: 'customer-invoice-fees/create',
            delete: 'customer-invoice-fees/delete/',
            update: 'customer-invoice-fees/update/',
            list: 'customer-invoice-fees/list',
        },
        multipleRecordPayment: {
            exportUpdate: 'invoice/export-record-payment',
            bulkUpdate: 'invoice/record-payments/bulk',
            compnay: 'invoice/list-of-company-for-invoice',
            customer: 'invoice/list-of-customer-for-invoice',
            list: 'invoice/record-payment-list',
        },
        recordPayments: 'invoice/record-payments/',
    },

    approvals: {
        getApprovalsListing: 'appointment/approvalList',
        getApprovalDetails: 'appointment/approvalDetail',
        createApproval: 'appointment/createApprovalForSaas',
        currentApproval: 'appointment/approvalDetail',
    },
    feedbackSubmit: {
        submitFeedback: 'feedback/send',
    },

    appointment: {
        saveNoteForCustomerInAppointment: 'appointment/update-appointment-note-for-customer/',
        addService: 'appointment/add-service/',
        deleteService: 'appointment/delete-service/',
        kanbanBoardList: 'appointment/appointmentListKanbanBoard',
        updateAppointmentStatus: 'appointment/updateAppointmentStatus',
        appointmentList: 'appointment/listForAppointment',
        appointmentDetails: 'appointment/detail',
        rescheduleAppointment: 'appointment/rescheduleAppointment',
        cancleAppointment: 'appointment/cancelAppointment',
        createAppointment: 'appointment/createAppointmentFromSaas',
        mechanicDetails: 'appointment/getAssignList',
        proposeDateAndTime: 'appointment/propose-new-time-saas',
        rescheduleRequestAcceptDecline: '/appointment/reschedule-accept-decline',
        shopClosingTime: 'shop/shopClosingTime',
    },
    calendar: {
        listing: 'calendar/list-for-saas',
        updateStatus: 'shopUnavailability/add-for-saas',
        availablityStatus: 'shopUnavailability/list-for-saas',
        getSetting: 'calendarSetting/list',
        addSetting: 'calendarSetting/add',
        editSetting: 'calendarSetting/update/',
        deleteSetting: 'calendarSetting/delete/',
        getAppointmentsStatus: 'calendar/view-preferance',
        editAssigneesSetting: 'shop/update-assignee-settings',
        getAssigneesSetting: 'shop/assignee-settings',
    },
    cometChat: {
        create: 'user/createChatUser',
    },
    pauseAppointment: {
        get: 'shop/getPauseAppointment',
        update: 'shop/pauseAppointment',
    },
    workOrderAuthorization: {
        create: 'work-order-authorization',
        detail: 'work-order-authorization/?workorderauthorizationid=',
        updateStatus: 'work-order-authorization/change-status/',
        history: 'work-order-authorization/history/',
    },
    config: {
        get: 'shop/config',
        put: 'shop/update-buffer-config',
        shopUpdate: 'shop/update-shop-config',
    },
    settings: {
        get: 'settings/get-mechanic-setting',
        getWithAuth: 'settings/get-mechanic-setting-with-auth',
    },
};

export { API };
